/**
 * ScrollX — contenedor con scroll horizontal + indicadores de borde (degradado)
 * que aparecen sólo cuando hay más contenido hacia ese lado (estilo Salonika).
 *
 *   fadeColor: color del degradado (debe igualar el fondo del contenedor).
 */
import { useCallback, useEffect, useRef, useState } from 'react'
import { cn } from '@/lib/utils'

export function ScrollX({ children, className, fadeColor = '#ffffff' }) {
  const ref = useRef(null)
  const [edges, setEdges] = useState({ left: false, right: false })

  const update = useCallback(() => {
    const el = ref.current
    if (!el) return
    const { scrollLeft, scrollWidth, clientWidth } = el
    setEdges({
      left: scrollLeft > 4,
      right: scrollLeft + clientWidth < scrollWidth - 4,
    })
  }, [])

  useEffect(() => {
    const el = ref.current
    if (!el) return undefined
    update()
    el.addEventListener('scroll', update, { passive: true })
    const ro = new ResizeObserver(update)
    ro.observe(el)
    return () => {
      el.removeEventListener('scroll', update)
      ro.disconnect()
    }
  }, [update])

  return (
    <div className="relative">
      <div ref={ref} className={cn('overflow-x-auto scrollbar-thin', className)}>
        {children}
      </div>
      {edges.left && (
        <div
          className="pointer-events-none absolute inset-y-0 left-0 w-12"
          style={{ background: `linear-gradient(to right, ${fadeColor}, transparent)` }}
        />
      )}
      {edges.right && (
        <div
          className="pointer-events-none absolute inset-y-0 right-0 w-14"
          style={{ background: `linear-gradient(to left, ${fadeColor}, transparent)` }}
        />
      )}
    </div>
  )
}
